import findById from 'helpers/findById'
import findAllButById from 'helpers/findAllButById'

export default function updateFloorPlan(state, action) {
  const { id, values } = action
  const floorPlan = findById({ state: state.map.floorPlans, id })
  const updatedFloorPlan = Object.assign({}, floorPlan, values)

  return Object.assign({}, state, {
    map: {
      ...state.map,
      floorPlans: [
        ...findAllButById({ state: state.map.floorPlans, id }).concat(updatedFloorPlan)
      ]
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/updateFloorPlan.js